import {Link} from 'react-router-dom'

import './notFound.css'
const NotFound = () => {
    return (
        <section>
            <div className="container notFound__container">
                <h2> Page Non Trouvé </h2>
                <Link to="/" className="btn" > Retour à L'Acceuil </Link>
            </div>
        </section>
    )
}

export default NotFound
